import { render, staticRenderFns } from "./TemplateAddress.vue?vue&type=template&id=b12ddaa0&"
import script from "./TemplateAddress.vue?vue&type=script&lang=ts&"
export * from "./TemplateAddress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports